export const dateFormat = (date: string | number | Date) => {
  return new Date(date).toLocaleString(undefined, {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  });
};

export const formatFileSize = (bytes: number): string => {
  if (bytes === 0) return '0 Bytes';

  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  const index = Math.floor(Math.log(bytes) / Math.log(k));

  return `${Number.parseFloat((bytes / Math.pow(k, index)).toFixed(2))} ${sizes[index]}`;
};

export const pluralize = (count: number, singular: string, plural: string): string => {
  return `${count.toLocaleString()} ${count === 1 ? singular : plural}`;
};

export const formatMatchPercentage = (value: number, maxDecimalPlaces: number = 5): string => {
  const clampedValue = Math.min(value, 100);
  const multiplier = Math.pow(10, maxDecimalPlaces);
  return (Math.floor(clampedValue * multiplier) / multiplier).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: maxDecimalPlaces,
  });
};
